<div class="p-grid">
  <div class="p-col-2">
    <h6>{{rm.fullName}}</h6>
    <!-- <p-button label="Go to Time Slots"></p-button> -->
  </div>
  <div class="p-col-10 multiselect">
    <h6>Zip Code(s)</h6>
    @if (rm) {
      <p-multiselect autofocusFilter placeholder=" " 
        [options]="zipCodeOptions"
        [(ngModel)]="rm.zipCodeAssignments"
        [panelStyle]="{minWidth:'12em'}"
        name="zipCodeAssignments"
        [disabled]="!canEdit"
        [showToggleAll]="false" fluid
        >
        <ng-template let-value pTemplate="selectedItems">
          @for (val of value; track val) {
            <div class="ui-multiselected-item-token ui-corner-all">
              <span>{{val.zipCode.code}} - {{val.zipCode.city}}</span>
            </div>
          }
          @if (!value || value.length === 0) {
            <span class="ui-multiselected-empty-token ui-corner-all">Choose</span>
          }
        </ng-template>
        <ng-template let-item pTemplate="item">
          {{item.label}}
        </ng-template>
      </p-multiselect >
    }
  </div>
</div>